export default __webpack_public_path__ + "static/C02-2c5deb72d20a2cad9f7654a3634a05c5.jpg";